import { render, staticRenderFns } from "./AlertStickyBar.vue?vue&type=template&id=5319d671&scoped=true"
import script from "./AlertStickyBar.vue?vue&type=script&lang=js"
export * from "./AlertStickyBar.vue?vue&type=script&lang=js"
import style0 from "./AlertStickyBar.vue?vue&type=style&index=0&id=5319d671&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5319d671",
  null
  
)

export default component.exports